import { cardBlogProjection } from '../Molecules/CardBlog.query';

// if you update this you made need to update CardBlog.query.ts because its used by torque/solr
export const suggestedContentQuery = groq`
  *[ _type == $type && excludeFromInternalSearchAndResourceCenter != true ] | order(_createdAt desc) [0...3] {
    ${cardBlogProjection}
  }
`;
